<template>
  <div>
    <Dialog
      :visible.sync="quotationDialog1"
      :style="{ width: '800px', height: '800px', overflowY: 'auto' }"
      header="Quotation Details"
      :modal="true"
      class="p-fluid"
      @keyup="keyMonitor"
    >
      <template #header>
        <h5>Quotation Details</h5>

        <span
          :key="statusKey"
          :class="'ignore pointer badge ' + getStyle(quotation.quoteStatus)"
        >
          {{
            quotation.quoteStatus && quotation.quoteStatus.statusName
              ? quotation.quoteStatus.statusName
              : ""
          }}
        </span>

        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </template>

      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="sQuoteNo">Quote No</label>
          <InputText
            id="sQuoteNo"
            :disabled="true"
            v-model.trim="quotation.sQuoteNo"
          />
        </div>
        <div class="p-field p-col">
          <label for="versionNo">Version No</label>
          <InputText
            :key="versionKey"
            id="versionNo"
            v-model.trim="quotation.versionNo"
            required="true"
            :disabled="true"
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="opportunity">Enquiry</label>
          <div class="p-inputgroup">
            <InputText
              placeholder="Click button to search for customer"
              :disabled="true"
              v-model="thisOpportunity.oppDescription"
              :class="{ 'p-invalid': submitted && !quotation.opportunity }"
            >
            </InputText>
            <Button
              id="opportunity"
              icon="pi pi-search"
              class="p-button-warning"
              @click="opportunitySelectionDialog = true"
              :disabled="disabledArr.includes('opportunity')"
              autofocus
            />
          </div>
          <small class="p-invalid" v-if="submitted && !quotation.opportunity"
            >Enquiry is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="customer">Customer</label>

          <div class="p-inputgroup">
            <InputText
              placeholder="Click button to search for customer"
              :disabled="true"
              id="customer"
              v-model="customerName"
              :class="{ 'p-invalid': submitted && !quotation.customer }"
            >
            </InputText>
          </div>
          <small class="p-invalid" v-if="submitted && !customerName"
            >Customer is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="mbpBranch">Branch *</label>
          <div v-if="mbpBranch">
            <InputText
              v-if="mbpBranch.branchName"
              :disabled="true"
              id="mbpBranch"
              v-model="mbpBranch.branchName"
            >
            </InputText>
            <InputText
              v-else-if="mbpBranch.branchCode"
              :disabled="true"
              id="mbpBranch"
              v-model="mbpBranch.branchCode"
            >
            </InputText>
          </div>
          <InputText v-else :disabled="true" id="mbpBranch"> </InputText>
        </div>
        <div class="p-field p-col">
          <label for="quoteVerDateMoment">Quote Date*</label>
          <Calendar
            id="quoteVerDate"
            v-model="quoteVerDate"
            dateFormat="dd/mm/yy"
            :showIcon="true"
            :disabled="disabledArr.includes('quoteVerDate')"
            :class="{ 'p-invalid': submitted && !quotation.quoteVerDate }"
            autofocus
          />
          <small class="p-invalid" v-if="submitted && !quotation.quoteVerDate"
            >Quote Date is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="createdByName">Created By</label>
          <InputText
            placeholder=""
            :disabled="true"
            v-model="createdBy.fullName"
          >
          </InputText>
        </div>
        <div class="p-field p-col">
          <label for="productValue">Product Value to Customer</label>
          <InputText
            id="productValue"
            placeholder=""
            @input="checkValue('productValue')"
            v-model="productValue"
            required="false"
            :disabled="disabledArr.includes('productValue')"
            :class="{ 'p-invalid': submitted && !quotation.productValue }"
          >
          </InputText>
          <!-- <InputNumber v-model="productValue" mode="currency" currency="USD" locale="en-US" /> -->
          <small class="p-invalid" v-if="submitted && !quotation.productValue"
            >Product Value is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="internalValue">Internal Value (optional)</label>
          <InputText
            id="internalValue"
            placeholder=""
            @input="checkValue('internalValue')"
            v-model.trim="internalValue"
            required="false"
            :disabled="disabledArr.includes('internalValue')"
          >
          </InputText>
        </div>
        <div class="p-field p-col">
          <label for="productQty">Product Qty</label>
          <InputNumber
            id="productQty"
            v-model.trim="productQty"
            required="false"
            :disabled="disabledArr.includes('productQty')"
            :class="{ 'p-invalid': submitted && !quotation.productQty }"
          />
          <small class="p-invalid" v-if="submitted && !quotation.productQty"
            >Product Quantity is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="quoteType.typeName">Product Type *</label>
          <Dropdown
            :showClear="true"
            v-model="productType"
            :options="productTypes"
            optionLabel="productTypeName"
            id="productType"
            placeholder="Select product type"
            :disabled="disabledArr.includes('productType')"
            :class="{
              'p-invalid': submitted && !(productType && productType.id)
            }"
          />
          <small
            class="p-invalid"
            v-if="submitted && !(productType && productType.id)"
            >Product Type required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="quoteGrade">Grade*</label>
          <Dropdown
            :showClear="true"
            v-model="quoteGrade"
            :options="quotationGrades"
            optionLabel="quoteGradeName"
            id="quoteGrade"
            placeholder="Select quotation grade"
            :disabled="disabledArr.includes('quoteGrade')"
            :class="{ 'p-invalid': submitted && !quotation.quoteGrade }"
            autofocus
          />
          <small class="p-invalid" v-if="submitted && !quotation.quoteGrade"
            >Grade is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="expOrderDateMoment">Expiry Order Date*</label>
          <Calendar
            id="expOrderDate"
            v-model="expiryDate"
            dateFormat="dd/mm/yy"
            :showIcon="true"
            :class="{ 'p-invalid': submitted && !quotation.expiryDate }"
            :disabled="disabledArr.includes('expOrderDate')"
          />
          <!-- <InputText
            id="expiryDate"
            v-model.trim="quotation.expiryDate"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !quotation.expiryDate }"
          /> -->
          <small class="p-invalid" v-if="submitted && !quotation.expiryDate"
            >Expiry Order Date is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="expOrderDateMoment">Expected Order Date (optional)</label>
          <Calendar
            id="expectedOrderDate"
            v-model="expectedOrderDate"
            dateFormat="dd/mm/yy"
            :showIcon="true"
            :disabled="disabledArr.includes('expectedOrderDate')"
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="reqDeliveryDateMoment">Req. Deliv. Date (optional)</label>
          <Calendar
            id="reqDeliveryDate"
            v-model="reqDeliveryDate"
            dateFormat="dd/mm/yy"
            :showIcon="true"
            :disabled="disabledArr.includes('reqDeliveryDate')"
          />
        </div>
        <div class="p-field p-col">
          <label for="chaseBy">Chase By (optional)</label>
          <Dropdown
            v-model="chaseBy"
            :options="users"
            optionLabel="fullName"
            placeholder="Select user"
            dataKey="id"
            :filter="true"
            :showClear="true"
            id="chaseBy"
            :disabled="disabledArr.includes('chaseBy')"
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="notes">Notes (optional)</label>
          <Textarea
            rows="2"
            :autoResize="true"
            id="notes"
            v-model.trim="quotation.notes"
            required="false"
            autofocus
            :disabled="disabledArr.includes('notes')"
          />
        </div>
      </div>

      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <ToggleButton
            v-model="openAttachment"
            onLabel="Do not want an attachment"
            offLabel="Attach a file"
            onIcon="pi pi-times"
            offIcon="pi pi-file"
          />
        </div>
      </div>

      <div
        id="dragFile"
        v-if="openAttachment"
        v-cloak
        @drop.prevent="addFile"
        @dragover.prevent
      >
        <div class="p-formgrid p-grid">
          <div class="p-field p-col-12" style="text-align: center;">
            <p>You can also drop the file in this section</p>
          </div>
        </div>

        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="file">File Name:</label>
            <InputText
              id="file"
              v-model.trim="fileName"
              required="true"
              disabled="true"
              autofocus
            />
          </div>
          <div class="p-field p-col">
            <label for="file">File Actions:</label>
            <div class="p-grid">
              <div class="p-lg-6">
                <Button
                  label="Remove file"
                  class="p-button-danger"
                  icon="pi pi-trash"
                  @click="clearFile"
                  iconPos="right"
                  :disabled="disabledArr.includes('clearFile')"
                />
              </div>
              <div class="p-lg-6">
                <Button
                  label="Add file"
                  class="p-button-info"
                  icon="pi pi-plus"
                  @click="clickButton"
                  iconPos="right"
                  :disabled="disabledArr.includes('clickButton')"
                />
                <input
                  single
                  type="file"
                  id="image1"
                  style="display: none;"
                  accept="*/*"
                  @change="onFileSelect"
                  :disabled="disabledArr.includes('onFileSelect')"
                />
                <!-- <FileUpload
                  class="test"
                  name="demo[]"
                  chooseLabel="Add file"
                  mode="basic"
                  :auto="true"
                  :customUpload="true"
                  @uploader="onFileSelect"
                /> -->
              </div>
            </div>
          </div>
        </div>

        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="file">File Description:</label>
            <Textarea
              rows="2"
              :autoResize="true"
              id="description"
              v-model.trim="file.attachDesc"
              required="false"
              autofocus
              :disabled="disabledArr.includes('attachDesc')"
            />
          </div>
        </div>
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="file">File Tags: (separatable with comma)</label>
            <MultiSelect
              v-model="attachTags"
              :options="tags"
              dataKey="id"
              optionLabel="tag"
              placeholder="Select tag/s"
              display="chip"
            />
          </div>
        </div>
      </div>

      <template #footer>
        <div class="p-grid" style="padding-top: 10px;">
          <div class="p-lg-4 p-md-3 p-sm-3"></div>
          <div class="p-lg-4 p-md-3 p-sm-3"></div>
          <div class="p-lg-2 p-md-3 p-sm-3">
            <Button
              label="Cancel"
              icon="pi pi-times"
              class="p-button-danger"
              style="width: 100px;"
              @click="hideDialog"
              :disabled="disabledArr.includes('hideDialog')"
            />
          </div>
          <div class="p-lg-2 p-md-3 p-sm-3">
            <ProgressSpinner
              v-if="sendingRequest"
              style="width:25px; height:25px; width: 100px;"
              strokeWidth="5"
              fill="#EEEEEE"
              animationDuration=".5s"
            />
            <Button
              v-else
              label="Save"
              icon="pi pi-check"
              class="p-button-success"
              style="width: 100px;"
              @click="saveQuote"
              :disabled="disabledArr.includes('saveQuote')"
            />
          </div>
        </div>
      </template>
    </Dialog>

    <OpportunitySelection
      :opportunitySelectionDialog="opportunitySelectionDialog"
      @close="close"
      @selected="selected"
    />
  </div>
</template>

<script>
import Dialog from "primevue/dialog";
import Dropdown from "primevue/dropdown";
import Button from "primevue/button";
import Textarea from "primevue/textarea";
import InputNumber from "primevue/inputnumber";
import InputSwitch from "primevue/inputswitch";
import ToggleButton from "primevue/togglebutton";

import OpportunityService from "@/service/OpportunityService";
import QuotationService from "@/service/QuotationService";
import SettingService from "@/service/SettingService";
import CustomerService from "@/service/CustomerService";
import UserService from "@/service/UserService";
import AttachmentService from "@/service/AttachmentService";
import TagsService from "@/service/TagsService";

import OpportunitySelection from "../opportunity/opportunitySelection";

import { quotationRequest } from "../sendRequest";

export default {
  components: {
    OpportunitySelection,
    Dropdown,
    InputSwitch,
    ToggleButton
  },
  props: {
    quotationDialog: {
      type: Boolean,
      required: true
    },
    active: {
      type: Boolean,
      required: false
    },
    opportunity: {
      type: Object,
      required: false
    },
    quoteToEdit: {
      type: Object,
      required: false
    },
    oppId: {
      type: Number,
      required: false
    },
    disabledArr: {
      type: Array,
      required: false
    }
  },
  data: () => ({
    settingService: new SettingService(),
    quotationService: new QuotationService(),
    opportunityService: new OpportunityService(),
    customerService: new CustomerService(),
    userService: new UserService(),
    attachmentService: new AttachmentService(),
    tagsService: new TagsService(),
    users: [],
    salesExecs: [],
    quoteStatuses: [],
    tempQuoteStatuses: [],
    custbranches: [],
    productTypes: [],
    quotationGrades: [],
    customers: [],
    selectedCustomer: {},
    customerName: "",
    custId: null,
    productType: null,
    quoteGrade: null,
    quotation: {},
    tempInternalVal: "",
    tempProductValue: "",
    tempProductQty: "",
    tempVersionNo: "",
    openAttachment: false,
    submitted: false,
    file: {},
    createdBy: {},
    mbpBranch: {},
    quoteVerDate: null,
    opportunitySelectionDialog: false,
    thisOpportunity: {},
    versionKey1: 0,
    tags: [],
    attachTags: null,
    statusKey1: 0,
    tempObj: {},
    productQty: null,
    productValue: null,
    chaseBy: null,
    internalValue: null,
    expectedOrderDate: null,
    reqDeliveryDate: null,
    expiryDate: null,
    sendingRequest: false
  }),
  computed: {
    versionKey: {
      set() {
        this.versionKey1++;
      },
      get() {
        return "versionKey-" + this.versionKey1.toString();
      }
    },
    statusKey: {
      set() {
        this.statusKey1++;
      },
      get() {
        return "statusKey-" + this.statusKey1.toString();
      }
    },
    quotationDialog1: {
      set(val) {
        if (!val) {
          this.$emit("close");
        }
      },
      get() {
        return this.quotationDialog;
      }
    },
    fileName: {
      get() {
        if (this.file.name) {
          return this.file.name;
        } else {
          return "";
        }
      },
      set(val) {
        // this.file.name = val
      }
    }
  },
  created() {
    this.setupComponent();
  },
  destroyed() {},
  mounted() {
    this.quotationService
      .getAllActiveQuotationStatuses()
      .then(data => {
        this.quoteStatuses = data;

        this.setQuoteStatus();
      })
      .catch(e => {
        if (e.response.status !== 200)
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting quotation statuses",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "activeQuoteStatuses"'
          });
      });
    this.opportunityService
      .getAllActiveProductTypes()
      .then(data => {
        this.productTypes = data;
      })
      .catch(e => {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting product types",
        //   life: 5000,
        // })
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "activeProductTypes"'
        });
      });
    this.opportunityService
      .getAllActiveQuotationGrades()
      .then(data => {
        this.quotationGrades = data;
      })
      .catch(e => {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting product types",
        //   life: 5000,
        // })
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "quotegrades"'
        });
      });

    this.getTagsOfType();
  },
  watch: {
    expiryDate(val) {
      if (val) {
        let day = val.getDate(),
          month = val.getMonth(),
          year = val.getFullYear();

        this.quotation.expiryDate = `${day.toString()}/${(
          month + 1
        ).toString()}/${year.toString()}`;
      } else {
        this.quotation.expiryDate = null;
      }
    },
    reqDeliveryDate(val) {
      this.quotation.reqDeliveryDate = val;
    },
    expectedOrderDate(val) {
      this.quotation.expectedOrderDate = val;
    },
    internalValue(val) {
      this.quotation.internalValue = val;
    },
    productValue(val) {
      this.quotation.productValue = val;
    },
    productQty(val) {
      this.quotation.productQty = val;
    },
    quoteToEdit(val) {
      //
      // if (val && val.quoteVerId) {
      // setTimeout(() => {
      this.setupComponent();
      // }, 5000)
      // }
    },
    chaseBy(val) {
      this.quotation.chaseBy = val;
    },
    createdBy(val) {
      this.quotation.createdBy = val;
    },
    mbpBranch(val) {
      this.quotation.mbpBranch = val;
    },
    thisOpportunity(val) {
      this.quotation.opportunity = val;
      this.loadOppData();
    },
    opportunity(val) {
      this.quotation.sQuoteNo = val.sQuoteNo;
      if (
        !(this.quoteToEdit && this.quoteToEdit.quoteVerId) &&
        this.opportunity.sQuoteNo
      ) {
        this.getVersionNumber(this.opportunity.sQuoteNo, this.opportunity.oppId);
      }
      this.thisOpportunity = val;

      if (this.thisOpportunity && this.thisOpportunity.salesExecId) {
        let salesEx = this.salesExecs.find(se => {
          if (se && se.id) {
            return se.id === this.thisOpportunity.salesExecId;
          }
        });

        let salesExecUser = this.users.find(user => {
          if (user && user.id && salesEx && salesEx.userId) {
            return user.id === salesEx.userId;
          }
        });

        this.chaseBy = salesExecUser;
      }
    },
    quoteStatuses(val) {
      // if (val && !(this.quoteToEdit && this.quoteToEdit.quoteVerId)) {
      //   this.quotation.quoteStatus = this.quoteStatuses.find(status => status.statusName === 'Active')
      // }
      this.setQuoteStatus();
    },
    quoteVerDate(val) {
      this.quotation.quoteVerDate = val;
      this.setExpiryDate();
    },
    productType(val) {
      if (val && val.expiryMonths) {
        this.quotation.productType = val;
        this.setExpiryDate();
      }
    },
    quoteGrade(val) {
      if (val && val.id) {
        this.quotation.quoteGrade = val;
      }
    }
  },
  methods: {
    setQuoteStatus() {
      if (this.quoteStatuses && this.quoteStatuses[0]) {
        if (this.active || !(this.quoteToEdit && this.quoteToEdit.sQuoteNo)) {
          this.quotation.quoteStatus = this.quoteStatuses.find(
            status => status.statusName === "Active"
          );
          this.statusKey++;
        }
      }
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    separateWithCommas(x) {
      let a = "",
        b = x.toString();
      for (let i = 0; i < b.length; i++) {
        if (i % 3 === 2) {
          a = a.concat(b[i] + ",");
        } else {
          a = a.concat(b[i]);
        }
      }
      if (a[a.length - 1] === ",") {
        return a.slice(0, a.length - 1);
      } else {
        return a;
      }
    },
    checkValue(field) {
      if (this[field]) {
        var value = "",
          arr = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "."];
        for (let i = 0; i < this[field].length; i++) {
          if (arr.includes(this[field][i])) {
            if (i === 0 && this[field][i] === ".") {
              value = value.concat("0" + this[field][i]);
            } else {
              value = value.concat(this[field][i]);
            }
            if (this[field][i] === ".") {
              arr.pop();
            }
          }
        }
        let parts = value.split("."),
          value1 = "";
        //
        parts[0] = this.numberWithCommas(parts[0]);
        value1 = value1.concat(parts[0]);
        if (parts[1]) {
          // parts[1] = this.separateWithCommas(parts[1])
          if (parts[1].length >= 2) {
            parts[1] = `${parts[1][0]}${parts[1][1]}`;
          }
          value1 = value1.concat("." + parts[1]);
        }
        if (value[value.length - 1] === ".") {
          value1 = value1.concat(".");
        }

        this[field] = value1;
      }
    },
    keyMonitor(event) {
      if (event.key === "Tab") {
        let a = document.activeElement;
        if (a) {
          let b = document.getElementsByClassName("p-datepicker p-component");
          b.forEach(c => {
            let found = false; // when moving from date to date (date === time)
            let found1 = true; // when going from date to dropdown (specially in primevue)

            c.parentElement.children.forEach(d => {
              //

              if (d.id === a.id) {
                found = true;
              }
              if (
                d.id &&
                a.parentElement.parentElement.id &&
                d.id !== a.parentElement.parentElement.id
              ) {
                found1 = false;
              }
            });
            //
            if (!found || !found1) {
              c.style.visibility = "hidden";
            }
          });
        }
      }
    },
    getVersionNumber(sQuoteNo, oppId) {
      this.quotation.versionNo = 0;
      this.versionKey++;

      this.quotationService
        .getVersionNumber(sQuoteNo, oppId)
        .then(response => {
          this.quotation.versionNo = response;
          this.versionKey++;
        })
        .catch(e => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting quote version no.",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "quotenextverno/{sQuoteNo}"'
          });
        });
    },
    setupComponent() {
      this.file = {};
      this.createdBy = {};
      this.customer = {};
      this.mbpBranch = {};
      this.quoteVerDate = "";
      this.productType = {};
      this.quoteGrade = {};
      this.submitted = false;
      this.productQty = null;
      this.productValue = null;
      this.internalValue = null;
      this.expectedOrderDate = null;
      this.reqDeliveryDate = null;
      this.tags = [];
      this.thisOpportunity = {};
      this.expiryDate = null;
      this.quotation = {};

      this.userService
        .getAllActiveUsers()
        .then(data => {
          this.users = data;
        })
        .catch(e => {
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from daud "activeUsers"'
          });
        });

      if (
        this.quoteToEdit &&
        this.quoteToEdit.quoteVerId &&
        this.$store.getters["auth/getMyProfile"]
      ) {
        Object.keys(this.quoteToEdit).forEach(key => {
          if (!this.quoteToEdit.quoteStatus) {
            this.quotation.quoteStatus = this.quoteStatuses.find(
              status => status.statusName === "Active"
            );
          }

          if (this.quoteToEdit[key] && this.quoteToEdit[key].id) {
            this.quotation[key] = { ...this.quoteToEdit[key] };

            if (key === "productType") {
              this.productType = { ...this.quoteToEdit[key] };
            } else if (key === "quoteGrade") {
              this.quoteGrade = { ...this.quoteToEdit[key] };
            } else if (key === "mbpBranch") {
              this.mbpBranch = { ...this.quoteToEdit[key] };
            } else if (key === "createdBy") {
              this.createdBy = { ...this.quoteToEdit[key] };
            } else if (key === "chaseBy") {
              this.chaseBy = this.quoteToEdit[key];
            }
          } else if (
            this.quoteToEdit[key] &&
            this.quoteToEdit[key].customerId
          ) {
            this.quotation[key] = this.quoteToEdit[key].customerId;
            this.customerName = this.quoteToEdit[key].custName;
            this.selectedCustomer = { ...this.quoteToEdit[key] };
          } else if (this.quoteToEdit[key] && this.quoteToEdit[key].oppId) {
            this.quotation[key] = { ...this.quoteToEdit[key] };
            this.thisOpportunity = { ...this.quoteToEdit[key] };
          } else {
            this.quotation[key] = this.quoteToEdit[key];
          }

          //

          if (key === "quoteVerDate") {
            let a = this.quoteToEdit[key].split("/");
            if (a.length >= 3)
              this.quoteVerDate = new Date(`${a[1]}/${a[0]}/${a[2]}`);
          } else if (key === "productQty") {
            var val = "",
              arr = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "."],
              subject = this.quoteToEdit[key];
            if (typeof subject === "number") {
              subject = subject.toString();
            }
            for (let i = 0; i < subject.length; i++) {
              if (arr.includes(subject[i])) {
                val = val.concat(subject[i]);
                if (subject[i] === ".") {
                  arr.pop();
                }
              }
            }
            this.quotation[key] = parseFloat(val);
            this.productQty = parseFloat(val);
          } else if (key === "expectedOrderDate") {
            this.quotation[key] = this.quoteToEdit[key];
            this.expectedOrderDate = this.quoteToEdit[key];
          } else if (key === "reqDeliveryDate") {
            this.quotation[key] = this.quoteToEdit[key];
            this.reqDeliveryDate = this.quoteToEdit[key];
          } else if (key === "productValue") {
            if (typeof this.quoteToEdit[key] === "string") {
              let data = this.quotation[key].toString(),
                a = [];

              if (data.substring(0, 1) === "£") {
                a = data.substring(1, this.quotation[key].length);
              } else {
                a = this.quotation[key];
              }

              let b = a.split(".");

              if (b.length > 2) {
                this.quotation[key] = 0;
                this.productValue = 0;
              } else {
                let c = b[0].split(","),
                  d = "";
                c.forEach(e => (d = d.concat(e)));
                if (b[1]) {
                  if (b[1].length < 2) {
                    this.quotation[key] = parseFloat(`${d}.${b[1]}0`);
                    this.productValue = parseFloat(`${d}.${b[1]}0`);
                  } else {
                    this.quotation[key] = parseFloat(`${d}.${b[1]}`);
                    this.productValue = parseFloat(`${d}.${b[1]}`);
                  }
                  this.quotation[key] = parseFloat(`${d}.${b[1]}`);
                  this.productValue = parseFloat(`${d}.${b[1]}`);
                } else {
                  this.quotation[key] = parseInt(d);
                  this.productValue = parseInt(d);
                }
              }
            } else {
              if (this.quotation[key]) {
                let a = this.quotation[key].toString(),
                  b = a.split(".");
                if (b[1] && b[1].length < 2) {
                  let no = `${b[0]}.${b[1]}0`;
                  this.productValue = no;
                  this.checkValue("productValue");
                } else {
                  this.productValue = this.quotation[key].toString();
                  this.checkValue("productValue");
                }
              }
            }
          } else if (key === "internalValue") {
            if (typeof this.quoteToEdit[key] === "string") {
              let data = this.quotation[key].toString(),
                a = [];

              if (data.substring(0, 1) === "£") {
                a = data.substring(1, this.quotation[key].length);
              } else {
                a = this.quotation[key];
              }

              let b = a.split(".");

              if (b.length > 2) {
                this.quotation[key] = 0;
                this.internalValue = 0;
              } else {
                let c = b[0].split(","),
                  d = "";
                c.forEach(e => (d = d.concat(e)));
                if (b[1]) {
                  if (b[1].length < 2) {
                    this.quotation[key] = parseFloat(`${d}.${b[1]}0`);
                    this.internalValue = parseFloat(`${d}.${b[1]}0`);
                  } else {
                    this.quotation[key] = parseFloat(`${d}.${b[1]}`);
                    this.internalValue = parseFloat(`${d}.${b[1]}`);
                  }
                } else {
                  this.quotation[key] = parseInt(d);
                  this.internalValue = parseInt(d);
                }
              }
            } else {
              if (this.quotation[key]) {
                let a = this.quotation[key].toString(),
                  b = a.split(".");
                if (b[1] && b[1].length < 2) {
                  let no = `${b[0]}.${b[1]}0`;
                  this.internalValue = no;
                  this.checkValue("internalValue");
                } else {
                  this.internalValue = this.quotation[key].toString();
                  this.checkValue("internalValue");
                }
              }
            }
          } else if (key === "expiryDate") {
            //
            let a = this.quotation[key].split("/");
            this.expiryDate = new Date(a[2], a[1] - 1, a[0]);
          }
        });
        //
      } else {
        if (this.quoteToEdit && this.quoteToEdit.chaseBy) {
          this.chaseBy = this.quoteToEdit.chaseBy;
        } else {
          this.customerService
            .getAllActiveSalesExecs()
            .then(data => {
              this.salesExecs = data;
              if (this.opportunity && this.opportunity.salesExecId) {
                let salesEx = this.salesExecs.find(se => {
                  if (se && se.id)
                    return se.id === this.opportunity.salesExecId;
                });
                let salesExecUser = this.users.find(user => {
                  if (user && user.id && salesEx && salesEx.userId)
                    return user.id === salesEx.userId;
                });
                this.chaseBy = salesExecUser;
              } else if (
                this.opportunity &&
                this.opportunity.salesExec &&
                this.opportunity.salesExec.id
              ) {
                let salesEx = this.salesExecs.find(se => {
                  if (se && se.id)
                    return se.id === this.opportunity.salesExec.id;
                });
                let salesExecUser = this.users.find(user => {
                  if (user && user.id && salesEx && salesEx.userId)
                    return user.id === salesEx.userId;
                });
                this.chaseBy = salesExecUser;
              }
            })
            .catch(e => {
              this.$store.dispatch("addErrorMessage", {
                severity: "error",
                content: 'Some data was not loaded from "activeSalesExecs"'
              });
            });
        }

        this.createdBy = this.$store.getters["auth/getMyProfile"];
        this.setQuoteStatus();

        // if (
        //   (
        //     this.active ||
        //     !(this.quoteToEdit && this.quoteToEdit.sQuoteNo)
        //   ) &&
        //   !(
        //     this.quotation &&
        //     this.quotation.quoteStatus
        //   ) &&
        //   (
        //     this.quoteStatuses &&
        //     this.quoteStatuses[0]
        //   )
        // ) {
        //   this.quotation.quoteStatus = this.quoteStatuses.find(status => status.statusName === 'Active')
        //   //
        // }
      }

      if (this.opportunity) {
        // this.quotation.opportunity = this.opportunity // this wil be done thisOpportunity watcher
        if (this.opportunity.oppId) this.thisOpportunity = this.opportunity;
        if (this.opportunity.sQuoteNo) {
          this.quotation.sQuoteNo = this.opportunity.sQuoteNo;
        }
        if (this.opportunity.mbpBranch && this.opportunity.mbpBranch.id)
          this.mbpBranch = this.opportunity.mbpBranch;
        if (this.opportunity.customer)
          this.quotation.customer = this.opportunity.customer;
        if (this.opportunity.custName)
          this.customerName = this.opportunity.customer.custName;
        if (this.opportunity.customer && this.opportunity.customer.custName)
          this.customerName = this.opportunity.customer.custName;
        if (this.opportunity.sQuoteNo)
          this.selectedCustomer = this.opportunity.customer;

        this.quotation.createdBy = this.$store.getters["auth/getMyProfile"].id;
      }
    },
    getStyle(data) {
      // according to: https://www.w3schools.com/bootstrap4/tryit.asp?filename=trybs_badges2&stacked=h
      if (data && data.colourCode) {
        return data.colourCode;
      } else if (
        data &&
        data.statusName &&
        data.statusName.toLowerCase() === "lost"
      ) {
        return "badge-danger";
      } else if (
        data &&
        data.statusName &&
        data.statusName.toLowerCase() === "active"
      ) {
        return "badge-primary";
      } else if (
        data &&
        data.statusName &&
        data.statusName.toLowerCase() === "won"
      ) {
        return "badge-success";
      } else if (
        data &&
        data.statusName &&
        data.statusName.toLowerCase() === "cancelled"
      ) {
        return "badge-warning";
      } else if (
        data &&
        data.statusName &&
        data.statusName.toLowerCase() === "revised"
      ) {
        return "badge-info";
      } else if (
        data &&
        data.statusName &&
        data.statusName.toLowerCase() === "closed"
      ) {
        return "badge-secondary";
      } else {
        return "badge-dark";
      }
    },
    getTagsOfType() {
      this.tagsService
        .getTagsOfType("ATTACHMENT")
        .then(data => {
          this.tags = data;
          // if (this.thisAttachment.attachTags)
          //   this.thisAttachment.attachTags = this.thisAttachment.attachTags.map(tag => data.find(t => t.tag === tag))
        })
        .catch(err => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while geting tags for ATTACHMENT",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "tags/type"'
          });
        });
    },
    selected(opportunity) {
      this.thisOpportunity = opportunity;
      this.opportunitySelectionDialog = false;
    },
    close() {
      this.opportunitySelectionDialog = false;
    },
    setExpiryDate() {
      if (
        this.quotation.productType &&
        this.quotation.productType.expiryMonths &&
        typeof this.quotation.quoteVerDate === "object" &&
        !this.expiryDate
      ) {
        let day = this.quotation.quoteVerDate.getDate(),
          month = this.quotation.quoteVerDate.getMonth(),
          year = this.quotation.quoteVerDate.getFullYear(),
          expiryMonth = month + this.quotation.productType.expiryMonths,
          diff = expiryMonth - 12;

        if (diff > 0) {
          expiryMonth = diff;
          year++;
        }
        this.expiryDate = new Date(
          year.toString(),
          expiryMonth.toString(),
          day.toString()
        );
        //
      } else {
        if (!this.quoteToEdit) this.quotation.expiryDate = "";
      }
    },
    clickButton() {
      document.getElementById("image1").click();
    },
    clearFile() {
      this.file = {};
    },
    addFile(e) {
      let droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) return;

      let a = droppedFiles[0];
      //
      a.fileName = a.name;
      this.file = a;
    },
    loadOppData() {
      if (this.quotation && this.quotation.opportunity) {
        if (
          this.quotation.opportunity.custName &&
          this.quotation.opportunity.customerId
        ) {
          this.customerName = this.quotation.opportunity.custName;
          this.selectedCustomer = {
            customerId: this.quotation.opportunity.customerId,
            custName: this.quotation.opportunity.custName
          };
        }
        if (
          this.quotation.opportunity.customer &&
          this.quotation.opportunity.customer.customerId
        ) {
          this.customerName = this.quotation.opportunity.customer.custName;
          this.selectedCustomer = this.quotation.opportunity.customer;
        }
        if (this.quotation.opportunity.mbpBranchId) {
          this.mbpBranch = {
            id: this.quotation.opportunity.mbpBranchId
          };
          if (this.quotation.opportunity.mbpBranchCode) {
            this.mbpBranch.branchCode = this.quotation.opportunity.mbpBranchCode;
          }
          if (this.quotation.opportunity.mbpBranchName) {
            this.mbpBranch.branchName = this.quotation.opportunity.mbpBranchName;
          }
        }
        this.quotation.sQuoteNo = this.quotation.opportunity.sQuoteNo;
        if (
          !(this.quoteToEdit && this.quoteToEdit.quoteVerId) &&
          this.quotation.sQuoteNo
        ) {
          this.getVersionNumber(
            this.quotation.sQuoteNo,
            this.quotation.opportunity && this.quotation.opportunity.oppId
          );
        }
        if (
          this.quotation.opportunity.mbpBranch &&
          this.quotation.opportunity.mbpBranch.id
        ) {
          this.mbpBranch = this.quotation.opportunity.mbpBranch;
        }
      }
    },
    onFileSelect(e) {
      if (e.target.files) {
        let a = e.target.files[0];
        //
        a.fileName = a.name;
        this.file = a;
      }
    },
    hideDialog() {
      this.$emit("close");
      this.submitted = false;
    },
    saveQuote() {
      this.submitted = true;
      this.sendingRequest = true;

      quotationRequest(this, "QuotationForm.vue");
    }
  }
};
</script>

<style scoped>
.pointer {
  cursor: auto;
  font-size: 16px;
}

#dragFile {
  padding: 10px;
  /* border: 3px dotted blue; */
  border: 1px solid rgb(108, 108, 255);
}

.scrollY {
  overflow-y: scroll;
}
</style>
